const promo_code = state => state.promo_code;
const coupon_id = state => state.coupon_id;

export {
    promo_code,
    coupon_id,
}